<template>
  <article class="Company">
    <header-background
      :image-src="headerImageSrc"
      class="Company-Banner"
      title="A Empresa"
    />

    <the-title class="Company-Title">Quem somos</the-title>

    <p class="Company-Paragraph">
      A CSC - Assessoria, Consultoria e Gestão Ltda é uma empresa prestadora de
      serviços especializada em Concursos Públicos, Processos Seletivos,
      Capacitações, Plano de Carreira, Recursos Humanos e Gestão.
    </p>

    <p class="Company-Paragraph">
      Composta por profissionais competentes e compromissados, sendo técnicos,
      graduados, especialistas, mestres e doutores, das mais variadas áreas
      profissionais.
    </p>

    <the-title class="Company-Title">Nossa missão</the-title>

    <p class="Company-Paragraph">
      Prestação de serviços a orgãos públicos e privados com qualidade e
      confiabilidade, construindo parcerias sólidas.
    </p>

    <the-title class="Company-Title">Nossa visão</the-title>

    <p class="Company-Paragraph">
      Consolidar-nos como empresa reconhecida e valorizada por suas
      contribuições.
    </p>

    <the-title class="Company-Title">Nossos valores</the-title>

    <p class="Company-Paragraph">
      Agir com ética e honestidade sempre, a fim de estabelecer relação de
      confiança com nossos clientes e parceiros.
    </p>

    <p class="Company-Paragraph">
      Valorizar as contribuições individuais e coletivas, para que possamos
      promover o desenvolvimento coletivo.
    </p>

    <the-title class="Company-Title">Atuação</the-title>

    <p class="Company-Paragraph">
      <router-link
        to="/area-de-atuacao"
        title="Clique aqui para conhecer nossas áreas de atuação"
      >Clique aqui para conhecer nossas áreas de atuação</router-link>
    </p>

    <the-title class="Company-Title">Nossos clientes</the-title>

    <p class="Company-Paragraph">
      Municípios já atendidos por nossos serviços:
    </p>

    <ul class="Company-List">
      <li class="Company-ListItem">
        Câmara Municipal de Águas de Santa Bárbara;
      </li>
      <li class="Company-ListItem">
        Prefeitura Municipal de Alfredo Marcondes;
      </li>
      <li class="Company-ListItem">Prefeitura Municipal de Álvares Machado;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Alvinlândia;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Andirá;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Anhumas;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Antonina;</li>
      <li class="Company-ListItem">Câmara Municipal de Araminas;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Assis;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Bastos;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Borá;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Caiabu;</li>
      <li class="Company-ListItem">Câmara Municipal de Cândido Mota;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Cândido Mota;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Carlópolis;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Coronel Macedo;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Cruzália;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Echaporã;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Emilianópolis;</li>
      <li class="Company-ListItem">
        Prefeitura Municipal de Flórida Paulista;
      </li>
      <li class="Company-ListItem">Prefeitura Municipal de Guaimbê;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Herculândia;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Ibirarema;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Iepê;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Ilha Solteira;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Indaiatuba;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Itaberá;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Itapeva;</li>
      <li class="Company-ListItem">Prefeitura Municipal de João Ramalho;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Junqueirópolis;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Lutécia;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Maraba Paulista;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Maracaí;</li>
      <li class="Company-ListItem">
        Prefeitura Municipal de Mirante do Paranapanema;
      </li>
      <li class="Company-ListItem">Prefeitura Municipal de Nantes;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Narandiba;</li>
      <li class="Company-ListItem">
        Prefeitura Municipal de Natividade da Serra;
      </li>
      <li class="Company-ListItem">Prefeitura Municipal de Oscar Bressane;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Palmital;</li>
      <li class="Company-ListItem">
        Prefeitura Municipal de Paraguaçu Paulista;
      </li>
      <li class="Company-ListItem">Prefeitura Municipal de Pardinho;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Pereiras;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Piquerobi;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Porangaba;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Pratânia;</li>
      <li class="Company-ListItem">
        Prefeitura Municipal de Presidente Epitácio;
      </li>
      <li class="Company-ListItem">Prefeitura Municipal de Quatá;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Rancharia;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Regente Feijó;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Rosana;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Sandovalina;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Santo Anastácio;</li>
      <li class="Company-ListItem">
        Prefeitura Municipal de São Luiz do Paraitinga;
      </li>
      <li class="Company-ListItem">Prefeitura Municipal de Taciba;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Timburi;</li>
      <li class="Company-ListItem">Prefeitura Municipal de Teodoro Sampaio;</li>
      <li class="Company-ListItem">Câmara Municipal de Tejupá.</li>
    </ul>

    <the-title class="Company-Title">Nossos Parceiros</the-title>

    <p class="Company-Paragraph">
      Alguns de Nossos Parceiros
    </p>

    <ul class="Company-List">
      <li class="Company-ListItem">
        CIVAP - Consórcio Intermunicipal do Vale do Paranapanema;
      </li>
      <li class="Company-ListItem">
        UNDIME - União Nacional dos Dirigentes Municipais de Educação - Polo
        Presidente Prudente;
      </li>
      <li class="Company-ListItem">
        CONTACEM - Contabilidade, Assessoria e Consultoria Empresarial.
      </li>
    </ul>
  </article>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .Company {
    width: 100%;

    &-Banner {
      margin-bottom: 10px;
    }

    &-Title {
      margin: 15px 20px;
    }

    &-Paragraph {
      margin: 15px 30px;
    }

    &-List {
      margin: 15px 30px;
    }
  }
</style>

<script>
  import HeaderBackground from "@/components/HeaderBackground";
  import TheTitle from "@/components/TheTitle";

  export default {
    name: "Company",

    components: {
      HeaderBackground,
      TheTitle,
    },

    data() {
      return {
        headerImageSrc: "/img/backgrounds/csc-03.jpg",
      };
    },

    mounted() {},
  };
</script>
